import React from 'react';
import { Box, Grid, TextField, Button, Checkbox, ListItemText, Chip } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useCallback, useMemo, useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import Logo from '../../../Media/Upload.jpeg';
import { useTranslation } from "react-i18next";
import InputAdornment from '@mui/material/InputAdornment';
import axios from "../../../utils/fvAxios";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import "../../../Localization/i18n";
import apiinfo from "../../../utils/base-uri.json";
import { ToastContainer, toast } from "react-toastify";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from "react-router-dom";

export default function EditVenorBusiness({ Vendorid, org, ansr }) {

  const [age, setAge] = React.useState("");
  const [year, setYear] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const handleChange1 = (event) => {
    setYear(event.target.value);
  };



  const venid = Vendorid == null ? org : Vendorid
  const activeStyle = {
    borderColor: '#2196f3'
  };

  const acceptStyle = {
    borderColor: '#00e676'
  };

  const rejectStyle = {
    borderColor: '#ff1744'
  };
  const {
    acceptedFiles,
    fileRejections,
    isDragActive,
    isDragAccept,
    isDragReject,
    getRootProps,
    getInputProps
  } = useDropzone({
    accept: {
      'image/png': []
    }
  });

  const style = useMemo(() => ({

    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isDragActive,
    isDragReject,
    isDragAccept
  ]);

  const acceptedFileItems = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      <ul>
        {errors.map(e => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ));
  const activeStyle2 = {
    borderColor: '#FFA500' // Example color
  };

  const acceptStyle2 = {
    borderColor: '#008000' // Example color
  };

  const rejectStyle2 = {
    borderColor: '#FF0000' // Example color
  };

  // Use the useDropzone hook for the second dropzone
  const {
    acceptedFiles: acceptedFiles2,
    fileRejections: fileRejections2,
    isDragActive: isDragActive2,
    isDragAccept: isDragAccept2,
    isDragReject: isDragReject2,
    getRootProps: getRootProps2,
    getInputProps: getInputProps2
  } = useDropzone({
    accept: {
      'image/png': []
    }
  });

  // Calculate the style for the second dropzone
  const style2 = useMemo(() => ({
    ...(isDragActive2 ? activeStyle2 : {}),
    ...(isDragAccept2 ? acceptStyle2 : {}),
    ...(isDragReject2 ? rejectStyle2 : {})
  }), [
    isDragActive2,
    isDragReject2,
    isDragAccept2
  ]);

  // Map over the accepted and rejected files for the second dropzone
  const acceptedFileItems2 = acceptedFiles2.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const fileRejectionItems2 = fileRejections2.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      <ul>
        {errors.map(e => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ));


  const { t } = useTranslation();



  const [editClient, setEditClient] = React.useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);



  const [name, setName] = useState('');
  const [tax, setTax] = useState('');
  const [PrincipalOfficerName, setPrincipalOfficerName] = useState('');
  const [City, setCity] = useState('');
  const [Zip, setZip] = useState('');
  const [Address, setAddress] = useState('');
  const [Address2, setAddress2] = useState('');
  const [Address3, setAddress3] = useState('');
  const [Telephone, setTelephone] = useState('');
  const [Phone, setPhone] = useState('');
  const [Fax, setFax] = useState('');
  const [url, setUrl] = useState('');
  const [state, setState] = useState('');
  const [registration, setRegistration] = useState('');
  const [SubClient, setSubClient] = useState('');
  const [country, setCountry] = useState('');
  const [accpectVendor, setAccpectVendor] = useState('');
  const [TrainingRequired, setTrainingRequired] = useState('');
  const [TrainingFeeCap, setTrainingFeeCap] = useState('');
  const [TrainingCertificate, setTrainingCertificate] = useState('');
  const [ExpirationPeriod, setExpirationPeriod] = useState('');
  const [RepresentativeName, setRepresentativeName] = useState('');
  const [RepresentativeEmail, setRepresentativeEmail] = useState('');
  const [InfusionSoftContactID, setInfusionSoftContactID] = useState('');
  const [copy, SetCopy] = useState('2');
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [counrtyid, setCounrtyid] = useState("");
  const [stateid, setStateid] = useState("");
  const [langauage, setlangauage] = useState([]);
  const [lang, setLang] = useState("");
  const [RegionsList, setRegionsList] = useState([]);
  const [RegionsListIds, setRegionsListIds] = useState([]);

  useEffect(() => {

    axios.get("Common/GetRegions")
      .then((res) => {
        if (res?.data?.responseCode === 100) {
          setRegionsList(res?.data?.data);
        }
        else {
          setError(res?.data?.responseMessage);
        }
      }).catch(err => {
        console.log(err)
      })

    axios.get(apiinfo.addressInfo.getCountries)
      .then((res) => {
        if (res?.data?.responseCode === 100) {
          setCountries(res?.data?.data)
        }
        else {
          setError(res?.data?.responseMessage);
        }
      }).catch(err => {
        console.log(err)
      })

    axios.get("Companies/EditVendor?organizationId=" + venid
    ).then((res) => {
      if (res.data.responseCode === 100) {
        const data = res?.data?.data;
        ansr(data?.vendorArchivedDetails)
        SetCopy(data?.copyAnswers == null ? "2" : data?.copyAnswers)
        setEditClient(data)
        setName(data?.name);
        setTax(data?.taxID);
        setPrincipalOfficerName(data?.principalCompanyOfficerName);
        setCity(data?.city);
        setZip(data?.zip);
        setAddress(data?.address1);
        setAddress2(data?.address2);
        setAddress3(data?.address3);
        setTelephone(data?.phoneNumber);
        setPhone(data?.extNumber);
        setFax(data?.faxNumber);
        setUrl(data?.websiteURL);
        setState(data?.state);
        setRegistration(data?.countryType);
        setSubClient(data?.SubClient);
        setRegionsListIds(data?.geographicArea)
        setCountry(data?.country);
        setAccpectVendor(data?.acceptVendorsViaInvite);
        setTrainingRequired(data?.trainingRequired);
        setTrainingFeeCap(data?.trainingFeeCap);
        setTrainingCertificate(data?.trainingCertificate);
        setExpirationPeriod(data?.ExpirationPeriod);
        setRepresentativeName(data?.orgRepresentativeName);
        setRepresentativeEmail(data?.orgRepresentativeEmail);
        setInfusionSoftContactID(data?.orgInfusionSoftContactId);
        setCounrtyid(res?.data?.data?.country);
        setStateid(res?.data?.data?.state);
        setLang(res?.data?.data?.language);
        setYear(data?.contractorEvaluationExpirationPeriod);
        setSelectedMonth(res?.data?.data?.financialMonth);
        setSelectedDate(res?.data?.data?.financialDate);


        axios.get(apiinfo.addressInfo.getStateByRegion + "clientID=" + 0 + "&country=" + res?.data?.data?.country)
          .then((res) => {
            if (res?.data?.responseCode === 100) {
              setStates(res?.data?.data)
            }
            else {
              setError(res?.data?.responseMessage);
            }
          }).catch(err => {
            console.log(err)
          });
        axios.get("Companies/GetCountryLanguages?countryName=" + res?.data?.data?.country)
          .then((res) => {
            if (res?.data?.responseCode === 100) {
              setlangauage(res?.data?.data)
            }
            else {
              setError(res?.data?.responseMessage);
            }
          }).catch(err => {
            console.log(err)
          });

      }
      else {
        setError(res.data.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      setIsLoading(false);
    });


  }, [refresh]);

  const getState = (e) => {
    if (e == "") {
      setError("please select country");
      setCounrtyid(e);
    } else {
      setError("");
      setCounrtyid(e);
      axios.get(apiinfo.addressInfo.getStateByRegion + "clientID=" + 0 + "&country=" + e)
        .then((res) => {
          if (res?.data?.responseCode === 100) {
            setStates(res?.data?.data)
          }
          else {
            setError(res?.data?.responseMessage);
          }
        }).catch(err => {
          console.log(err)
        })
      axios.get("Companies/GetCountryLanguages?countryName=" + e)
        .then((res) => {
          if (res?.data?.responseCode === 100) {
            setlangauage(res?.data?.data)
          }
          else {
            setError(res?.data?.responseMessage);
          }
        }).catch(err => {
          console.log(err)
        })
    }
  }
  const [selectedMonth, setSelectedMonth] = useState(""); // Set a default month
  const [selectedDate, setSelectedDate] = useState(""); // Set a default date
  useEffect(() => {
    setSelectedMonth(""); // Set the default selected month to ""
  }, []);
  const generateDays = (month) => {
    switch (month) {
      case 1: // January
      case 3: // March
      case 5: // May
      case 7: // July
      case 8: // August
      case 10: // October
      case 12: // December
        return Array.from({ length: 31 }, (_, i) => (i + 1).toString());
      case 4: // April
      case 6: // June
      case 9: // September
      case 11: // November
        return Array.from({ length: 30 }, (_, i) => (i + 1).toString());
      case 2: // February
        // Assuming a non-leap year
        return Array.from({ length: 28 }, (_, i) => (i + 1).toString());

      default:
        return [];
    }
  };



  const [phoneError, setPhoneError] = useState(null);
  const [telephoneError, setTelephoneError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [faxError, setFaxError] = useState(null);
  const validatePhoneNumber = (phoneNumber) => {
    const regex = /^\(\d{3}\) \d{3}-\d{4}$/;
    return regex.test(phoneNumber);
  };
  const validateNumber = (email) => {
    const regex = /^\(\d{3}\) \d{3}-\d{4}$/;
    return email === '' || regex.test(email);
  };

  const validateEmail = (email) => {
    const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,20}$/;
    return email === '' || regex.test(email);
  };
  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    const numericInput = inputValue.replace(/[^0-9]/g, '');
    if (numericInput.length <= 10) {
      if (numericInput === '') {
        // Field is empty, no error
        setTelephone('');
        setTelephoneError(true);
      } else if (/^\d{10}$/.test(numericInput)) {
        const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
        setTelephone(formattedInput);
        setTelephoneError(false);
      } else {
        setTelephone(numericInput);
        setTelephoneError(true);
      }
    } else {
      // Limit to 10 digits, no further input allowed
      setTelephone(numericInput.slice(0, 9));
      setTelephoneError(true);
    }
  };

  const navigate = useNavigate();
  const handleSubmit = (event) => {
    event.preventDefault();
    if (!name || !Address || !Zip || !counrtyid || !Telephone || !stateid || !City || !PrincipalOfficerName || !tax) {
      toast.error("Please fill all the mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    } else {
      setIsLoading(true);
      const formData = new FormData();
      formData.append('SingleClientCode', editClient?.singleClientCode == null ? "" : editClient?.singleClientCode);
      formData.append('CopyAnswers', copy);
      formData.append('QuestionarieTypeIdForPrequalRequirements', editClient?.questionarieTypeIdForPrequalRequirements == null ? "" : editClient?.questionarieTypeIdForPrequalRequirements);
      formData.append('FederalIDNumber', editClient?.federalIDNumber == null ? "" : editClient?.federalIDNumber);
      formData.append('Zip', Zip == null ? "" : Zip);
      formData.append('ContractorEvaluationExpirationPeriod', "");
      formData.append('OrgInfusionSoftContactId', InfusionSoftContactID == null ? "" : InfusionSoftContactID);
      formData.append('IntroContentStr', editClient?.introContentStr == null ? "" : editClient?.introContentStr);
      formData.append('isCompanyExist', editClient?.isCompanyExist == null ? "" : editClient?.isCompanyExist);
      formData.append('OrgnaizationPhoto', acceptedFiles2[0]);///////////////////////////////
      formData.append('TrainingFeeCap', TrainingFeeCap == null ? "" : TrainingFeeCap);
      formData.append('FaxNumber', Fax == null ? "" : Fax);
      formData.append('TaxID', tax);
      formData.append('LogoBlob', editClient?.logoBlob == null ? "" : editClient?.logoBlob);
      formData.append('QuestionarieTypeId', editClient?.questionarieTypeId == null ? "" : editClient?.questionarieTypeId);
      formData.append('MoodleTrainingRequired', editClient?.moodleTrainingRequired == null ? "" : editClient?.moodleTrainingRequired);
      formData.append('ExtNumber', Phone == null ? "" : Phone);
      formData.append('ConfirmDelete', editClient?.confirmDelete == null ? "" : editClient?.confirmDelete);
      formData.append('City', City == null ? "" : City);
      formData.append('Logo', editClient?.logo == null ? "" : editClient?.logo);
      formData.append('Name', name == null ? "" : name);
      formData.append('OrgRepresentativeName', RepresentativeName == null ? "" : RepresentativeName);
      formData.append('OrganizationType', editClient?.organizationType == null ? "" : editClient?.organizationType);
      formData.append('GeographicArea', RegionsListIds?.toString() ? RegionsListIds?.toString() : []);
      formData.append('OrganizationID', org == null ? "" : org);
      formData.append('PhotoBlob', editClient?.photoBlob == null ? "" : editClient?.photoBlob);
      formData.append('CountryType', registration == null ? "" : registration);
      formData.append('State', stateid == null ? "" : stateid);
      formData.append('PrincipalCompanyOfficerName', PrincipalOfficerName == null ? "" : PrincipalOfficerName);
      formData.append('Photo', editClient?.photo == null ? "" : editClient?.photo);
      formData.append('AcceptVendorsViaInvite', accpectVendor == null ? "" : accpectVendor);
      formData.append('WebsiteURL', url == null ? "" : url);
      formData.append('Country', counrtyid == null ? "" : counrtyid);
      formData.append('PhoneNumber', Telephone == null ? "" : Telephone);
      formData.append('FinancialMonth', selectedMonth == null ? "" : selectedMonth);
      formData.append('FinancialDate', selectedDate == null ? "" : selectedDate);
      formData.append('OrgnaizationLogo', acceptedFiles[0]);////////////////////////////////////////////
      formData.append('Language', lang == null ? "" : lang);
      formData.append('TrainingRequired', TrainingRequired == null ? "" : TrainingRequired);
      formData.append('isSuccess', editClient?.isSuccess == null ? "" : editClient?.isSuccess);
      formData.append('OrgRepresentativeEmail', RepresentativeEmail == null ? "" : RepresentativeEmail);
      formData.append('EmployeeSelfRegistrationURL', editClient?.employeeSelfRegistrationURL == null ? "" : editClient?.employeeSelfRegistrationURL);
      formData.append('ClientSecrte', editClient?.clientSecrte == null ? "" : editClient?.clientSecrte);
      formData.append('TrainingCertificate', TrainingCertificate == null ? "" : TrainingCertificate);
      formData.append('Address1', Address == null ? "" : Address);
      formData.append('Address2', Address2 == null ? "" : Address2);
      formData.append('Address3', Address3 == null ? "" : Address3);
      axios
        .post('Companies/SaveVendor',
          formData,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((res) => {
          if (res?.data?.responseCode == "100") {
            toast.success(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setRefresh(!refresh);
          } else {
            toast.error(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };


  const ChangeState = (e) => {
    setStateid(e);
  }

  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };
  const [openpop, setOpenpop] = React.useState(false);

  const handleClickOpenpop = (e) => {
    setOpenpop(true);
  };
  const handlePopClose = () => {
    setOpenpop(false);

  };
  const handleDelete = () => {
    setIsLoading(true);
    setOpenpop(false);
    axios
      .post("Companies/DeleteCompany?vendorId=" + venid,
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        if (res?.data?.responseCode == "100") {
          toast.success(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setRefresh(!refresh);
          navigate("/SearchCompany");
        } else {
          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (

    <>
      <Dialog
        open={openpop}
        keepMounted
        onClose={handlePopClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="sm" // Set the maximum width to 416px
      >
        <DialogTitle>{"Are you sure you want to delete this company?"}</DialogTitle>
        <DialogContent>
          {"Deleting this company will delete all data associated with this company including prequalification data, documents, comments, user, employees, etc. This operation is irreversible."}
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center' }}>
          {/* Remove the existing buttons */}
          {/* New Cancel button */}
          <Button
            variant="outlined"
            color="primary" // You can customize the color here
            style={{ padding: "20px", width: "150px" }}
            onClick={handlePopClose}
          >
            Cancel
          </Button>
          {/* New "Yes, Delete" button */}
          <Button
            style={{ backgroundColor: '#EE3F3F', color: 'white', padding: "20px", width: "150px" }}
            onClick={handleDelete}
          >
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />
      <Box>
        <Box
          border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec"
          className="mt-2"
          sx={{ background: "#fff" }}
        >
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "10px" }}
          >
            <Grid item xs={12} sm={4} md={4} >
              <p
                className="mt-2"
                style={{ fontSize: "500px", color: "#3E4A62", fontSize: "20px", fontWeight: "500", marginBottom: 0 }}
              >
                {t('ClientEditBusinessInfo.label1')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}></Grid>
          </Grid>
          <hr hidden={!editClient.clients} />
          <Grid
            hidden={!editClient.clients}
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label2')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="Age"
                  onChange={handleChange}
                  hidden={!editClient.clients}
                  size="small"
                  MenuProps={MenuProps}
                  sx={{
                    width: "299px",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    width: "299px"
                  }}
                >
                  <MenuItem value={10}>all</MenuItem>
                  <MenuItem value={20}>Twenty</MenuItem>
                  <MenuItem value={30}>Thirty</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label3')}<span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={registration}
                  onChange={(event) => setRegistration(event.target.value)}
                >
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="U. S."
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="International"
                  />
                </RadioGroup>

              </FormControl>
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label4')} <span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={name}
                onChange={(event) => setName(event.target.value)}
                required
                // error={!name}
                // helperText={!name && 'Name is required'} 
                size="small"
                id="outlined-name"
                fullWidth

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label5')} <span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={tax}
                onChange={(event) => setTax(event.target.value)}
                required
                // error={!name}
                // helperText={!name && 'Name is required'} 
                size="small"
                id="outlined-name"
                fullWidth

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label6')} <span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={PrincipalOfficerName}
                onChange={(event) => setPrincipalOfficerName(event.target.value)}
                required
                // error={!name}
                // helperText={!name && 'Name is required'} 
                size="small"
                id="outlined-name"
                fullWidth

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label7')}<span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                  width: "299px"
                }}
                select
                required
                size='small'
                placeholder={t('Mycompany.country')}
                name="country"
                id="country"
                value={counrtyid || ""}
                className="form-control text-feild-custom "
                onChange={(e) => getState(e.target.value)}
                MenuProps={MenuProps}
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      style: {
                        maxHeight: 350, // Set the maximum height here
                      },
                    },
                  },
                }}
              >
                {countries?.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.value}
                  </MenuItem>
                ))}
              </TextField>

            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label8')}<span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                  width: "299px"
                }}
                select
                type="state"
                id='state'
                size='small'
                required
                MenuProps={MenuProps}
                name="state"
                value={stateid || ""}
                onChange={(e) => ChangeState(e.target.value)}
                placeholder={t('Mycompany.state')}
                className="form-control text-feild-custom "
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      style: {
                        maxHeight: 350, // Set the maximum height here
                      },
                    },
                  },
                }}
              >
                {states?.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.value}
                  </MenuItem>
                ))}
              </TextField>

            </Grid>
          </Grid>
          <hr />
          {/* lang */}
          {/* day */}
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                Language <span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <FormControl fullWidth>

                <Select
                  value={lang}
                  onChange={(event) => setLang(event.target.value)}
                  required
                  variant="outlined"
                  size="small"
                  MenuProps={MenuProps}
                  sx={{
                    '& legend': { display: 'none' },
                    '& fieldset': { top: 0 },
                    width: "299px"
                  }}
                >
                  {langauage?.map((item, index) => (
                    <MenuItem key={index} value={item.key}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

            </Grid>
          </Grid>
          <hr />
          {/* month */}
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                Fiscal Year-end Month
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <FormControl fullWidth>

                <Select
                  value={selectedMonth || ""}
                  onChange={(event) => {
                    setSelectedMonth(event.target.value);
                    setSelectedDate('');
                  }}
                  MenuProps={MenuProps}
                  required
                  variant="outlined"
                  size="small"
                  sx={{
                    '& legend': { display: 'none' },
                    '& fieldset': { top: 0 },
                    width: "299px"
                  }}
                >
                  <MenuItem value="">Select</MenuItem>
                  <MenuItem value={1}>January</MenuItem>
                  <MenuItem value={2}>February</MenuItem>
                  <MenuItem value={3}>March</MenuItem>
                  <MenuItem value={4}>April</MenuItem>
                  <MenuItem value={5}>May</MenuItem>
                  <MenuItem value={6}>June</MenuItem>
                  <MenuItem value={7}>July</MenuItem>
                  <MenuItem value={8}>August</MenuItem>
                  <MenuItem value={9}>September</MenuItem>
                  <MenuItem value={10}>October</MenuItem>
                  <MenuItem value={11}>November</MenuItem>
                  <MenuItem value={12}>December</MenuItem>
                </Select>
              </FormControl>

            </Grid>
          </Grid>
          <hr />
          {/* day */}
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                Fiscal Year-end Day
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <FormControl fullWidth>

                <Select
                  value={selectedDate}
                  onChange={(event) => setSelectedDate(event.target.value)}
                  required
                  variant="outlined"
                  size="small"
                  MenuProps={MenuProps}
                  sx={{
                    '& legend': { display: 'none' },
                    '& fieldset': { top: 0 },
                    width: "299px"
                  }}
                >
                  {generateDays(selectedMonth).map((day) => (
                    <MenuItem key={day} value={day}>
                      {day}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label9')}<span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={City}
                onChange={(event) => setCity(event.target.value)}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label10')}<span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={Zip}
                onChange={(event) => setZip(event.target.value)}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label11')}<span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={Address}
                onChange={(event) => setAddress(event.target.value)}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label12')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={Address2}
                onChange={(event) => setAddress2(event.target.value)}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label13')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={Address3}
                onChange={(event) => setAddress3(event.target.value)}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label14')}<span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                  width: '299px',
                }}
                value={Telephone}
                onInput={handleInputChange}
                size="small"
                id="outlined-name"
                variant="outlined"
                error={telephoneError}
                helperText={telephoneError ? 'Invalid phone number format. Use (xxx) xxx-xxxx' : ''}
              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label15')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={Phone}
                // onChange={(event) => setPhone(event.target.value)}
                onChange={(event) => {
                  const inputValue = event.target.value;
                  const numericInput = inputValue.replace(/[^0-9]/g, '');

                  if (numericInput.length <= 10) {
                    if (numericInput === '') {
                      // Field is empty, no error
                      setPhone('');
                      setPhoneError(false);
                    } else if (numericInput) {
                      const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
                      setPhone(numericInput);
                      setPhoneError(false);
                    } else {
                      setPhone(numericInput);
                      setPhoneError(true);
                    }
                  } else {
                    // Limit to 10 digits, no further input allowed
                    // setPhone(numericInput.slice(0, 10));
                    setPhone(numericInput);
                    setPhoneError(false);
                  }
                }}
                error={phoneError}
                helperText={phoneError ? 'Use only number format' : ''}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label16')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={Fax}
                onChange={(event) => {
                  const inputValue = event.target.value;
                  const numericInput = inputValue.replace(/[^0-9]/g, '');

                  if (numericInput.length <= 10) {
                    if (numericInput === '') {
                      // Field is empty, no error
                      setFax('');
                      setFaxError(false);
                    } else if (/^\d{10}$/.test(numericInput)) {
                      const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
                      setFax(formattedInput);
                      setFaxError(false);
                    } else {
                      setFax(numericInput);
                      setFaxError(true);
                    }
                  } else {
                    // Limit to 10 digits, no further input allowed
                    setFax(numericInput.slice(0, 10));
                    setFaxError(true);
                  }
                }}
                error={faxError}
                helperText={faxError ? 'Invalid Faxnumber format use (xxx) xxx-xxxx' : ''}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {t('ClientEditBusinessInfo.label17')}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start" ><Box  >http:// </Box></InputAdornment>,
                }}

                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={url}
                onChange={(event) => setUrl(event.target.value)}
                size="small"
                id="outlined-name"

              />

            </Grid>
          </Grid>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={12} md={12}>
              {/* <div style={{float:"right", marginBottom:"10px"}}>
          <Button variant="contained"sx={{padding:"10px"}} onClick={handleSubmit}>{t('ClientEditBusinessInfo.label18')}</Button></div> */}

            </Grid>

          </Grid>



        </Box>
      </Box>



      <Box>
        <Box
          border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec"
          className="mt-2"
          sx={{ padding: "10px", background: "#fff" }}
        >

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                Prequalification Information
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}></Grid>
          </Grid>
          <hr />

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                Copy Answers from Previous Prequalification<span style={{ color: "red" }}>*</span>
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>

              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={copy}
                  onChange={(event) => SetCopy(event.target.value)}

                >
                  <FormControlLabel
                    value={2}
                    control={<Radio />}
                    label="Copy Answers"
                  />
                  <FormControlLabel
                    value={0}
                    control={<Radio />}
                    label="Do Not Copy Answers"
                  />
                </RadioGroup>

              </FormControl>
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                Representative Name
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={RepresentativeName}
                onChange={(event) => setRepresentativeName(event.target.value)}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                Representative Email
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                  width: '299px',
                }}
                value={RepresentativeEmail}
                onChange={(event) => {
                  const email = event.target.value;
                  setRepresentativeEmail(email);
                  const isValid = validateEmail(email);
                  setEmailError(!isValid);
                }}
                size="small"
                id="outlined-name"
                variant="outlined"
                error={emailError}
                helperText={emailError ? 'Invalid email format' : ''}
              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                InfusionSoft ContactID
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "299px"
                }}
                value={InfusionSoftContactID}
                onChange={(event) => setInfusionSoftContactID(event.target.value)}
                size="small"
                id="outlined-name"

              />
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                Vendor Operating Region
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <FormControl>

                <Select
                  labelId="docs-label"
                  id="docs-select"
                  multiple
                  size='small'
                  sx={{
                    '& legend': { display: 'none' },
                    '& fieldset': { top: 0 },
                    width: "299px",
                  }}
                  name="Site Safety Representive"
                  value={RegionsListIds || []}
                  MenuProps={MenuProps}
                  renderValue={(selected) =>
                    selected
                      .map((value) => RegionsList?.find((doc) => doc?.value === value)?.value)
                      .filter((text) => text !== undefined)
                      .join(", ")
                  }
                  onChange={(e) => setRegionsListIds(e?.target?.value)}
                >
                  {RegionsList?.map((r, i) => (
                    <MenuItem key={i} value={r?.value}>
                      <Checkbox checked={RegionsListIds?.indexOf(r?.value) > -1} />
                      <ListItemText primary={r?.value} />

                    </MenuItem>
                  ))}
                </Select>

              </FormControl>

            </Grid>
          </Grid>
          <hr />
          {/* <div className="drop" {...getRootProps({ style })} >
                <img className='mt-2' src={Logo} alt="" />
                <br />
                <input className="mt-2" type="file" {...getInputProps()} onChange={saveFile} />

                <span className='text-muted mt-2 fs'><b><span className='mx-1 cl'>{t('DragandDrop.firstLabel1')}</span>
                  { }</b></span>
                <br />
                <span className=' text-muted Fs'>
                  {t('DragandDrop.secondLabel')}</span>
                <span className=' text-muted Fs'> {thumbs}</span>
              </div> */}
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                Select Logo
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={3}>

              <div {...getRootProps({ style })} className="drop">
                <img className='mt-2' src={Logo} alt="" />
                <br />
                <input {...getInputProps()} />

                <span className='text-muted mt-2 fs'><b><span className='mx-1 cl'>{t('DragandDrop.firstLabel1')}</span>
                  { }</b></span>
                <br />
                <span className=' text-muted Fs'>
                  {t('Only Png Allowed')}
                </span>
                <span className=' text-muted Fs'> {acceptedFileItems}</span>
              </div>

            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                Select Photo
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={3}>

              <div {...getRootProps2({ style })} className="drop">
                <img className='mt-2' src={Logo} alt="" />
                <br />
                <input {...getInputProps2()} />
                <span className='text-muted mt-2 fs'>
                  <b><span className='mx-1 cl'>{t('DragandDrop.firstLabel1')}</span></b>
                </span>
                <br />
                <span className=' text-muted Fs'>
                  {t('Only Png Allowed')}
                </span>
                <span className=' text-muted Fs'> {acceptedFileItems2}</span>



              </div>

            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {"Vendor Code"}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={3}>
              {editClient?.singleClientCode}
            </Grid>
          </Grid>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={12} md={12}>
              <div style={{ float: "right", marginBottom: "10px" }}>
                <Button variant="contained" sx={{ padding: "10px" }} onClick={handleSubmit} disabled={phoneError || telephoneError || emailError || faxError}>{t('ClientEditBusinessInfo.label18')}</Button></div>

            </Grid>

          </Grid>
        </Box>

        <Box
          border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec"
          className="mt-2"
          sx={{ background: "#fff" }}
        >
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "10px" }}
          >
            <Grid item xs={12} sm={4} md={4} >
              <p
                className="mt-2"
                style={{ fontSize: "500px", color: "#3E4A62", fontSize: "20px", fontWeight: "500", marginBottom: 0 }}
              >
                Danger Zone
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}></Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            sx={{ padding: "15px" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                {"Delete Company"}
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={3}>
              <Button style={{ color: "#EE3F3F", cursor: "pointer", textTransform: "captalization", fontSize: "18px" }} onClick={() => handleClickOpenpop()}><DeleteOutlineIcon />Delete</Button>
            </Grid>
          </Grid>

        </Box>
      </Box>
      {/* <Box>
        <Box
          border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec"
          className="mt-2"
          sx={{ padding: "10px", background: "#fff", marginBottom: "10px" }}
        >
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <p
                style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}
              >
                Danger Zone
              </p>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
            </Grid>
          </Grid>
        </Box>
      </Box> */}
    </>
  )
}
